
export function initFaq() {

  
  (function () {
    const tablist = document.querySelector('.wr-abag-tabs');
    if (!tablist) return;

    const tabs = Array.from(tablist.querySelectorAll('.wr-abag-tab'));
    const panels = tabs
      .map(btn => document.querySelector(btn.dataset.wrAbagTarget))
      .filter(Boolean);

    function activateTab(btn, { focusPanel = false } = {}) {
      const targetSel = btn.dataset.wrAbagTarget;
      const panel = document.querySelector(targetSel);
      if (!panel) return;

      
      tabs.forEach(t => t.setAttribute('aria-selected', String(t === btn)));
      tabs.forEach(t => t.classList.toggle('is-active', t === btn));

      
      panels.forEach(p => {
        const isActive = ('#' + p.id === targetSel);
        p.hidden = !isActive;
        if (isActive) p.setAttribute('tabindex', '-1');
      });

      
      

      
      if (focusPanel) {
        panel.focus({ preventScroll: true });
      }

      
      panel.dispatchEvent(new CustomEvent('wr-abag:activated', {
        bubbles: true,
        detail: { panelId: panel.id }
      }));
    }

    
    tablist.addEventListener('click', (e) => {
      const btn = e.target.closest('.wr-abag-tab');
      if (!btn) return;
      e.preventDefault(); 
      activateTab(btn, { focusPanel: false });
    });

    
    tablist.addEventListener('keydown', (e) => {
      const current = document.activeElement.closest('.wr-abag-tab');
      if (!current) return;

      const idx = tabs.indexOf(current);
      let nextIdx = idx;

      switch (e.key) {
        case 'ArrowRight':
        case 'PageDown':
          nextIdx = (idx + 1) % tabs.length;
          break;
        case 'ArrowLeft':
        case 'PageUp':
          nextIdx = (idx - 1 + tabs.length) % tabs.length;
          break;
        case 'Home':
          nextIdx = 0;
          break;
        case 'End':
          nextIdx = tabs.length - 1;
          break;
        case 'Enter':
        case ' ':
          activateTab(current, { focusPanel: true });
          e.preventDefault();
          return;
        default:
          return;
      }
      tabs[nextIdx].focus();
      e.preventDefault();
    });

    
    function initFromHash() {
      const hash = window.location.hash;
      if (hash) {
        const match = tabs.find(b => b.dataset.wrAbagTarget === hash);
        if (match) {
          activateTab(match);
          return true;
        }
      }
      return false;
    }

    const didHashInit = initFromHash();
    if (!didHashInit) {
      const defaultTab = tabs.find(t => t.getAttribute('aria-selected') === 'true') || tabs[0];
      if (defaultTab) activateTab(defaultTab);
    }

    
    window.addEventListener('hashchange', () => {
      const match = tabs.find(b => b.dataset.wrAbagTarget === location.hash);
      if (match) activateTab(match);
    });
  })();

}
